module.exports = __webpack_public_path__ + "static/media/role.ec0245e8.svg";